import { useState } from "react";
import { updateOnBoardingTracker } from "../Store/apiStore";

import decodeToken from "../lib/decodeToken";

export default function useOnboardingTracker() {
  const [steps, setSteps] = useState([]);
  const trackStep = async ({ stepName,stepNo, screenName, email, userId, data, agentId, flowType }) => {



    const entry = {
      stepName,
      stepNo,
      screenName,
      userId: userId,
      email: email,
      data: data || {},
      timestamp: new Date().toISOString(),
      sessionId: `session_${Date.now()}_${Math.random().toString(36).slice(2)}`,
      flowType: flowType,
      agentId: agentId
    };
    // add new tracking step
    setSteps(prev => [...prev, entry]);

    // NOTE: trackStep no longer mirrors steps into GA4. It used to fire
    // trackEvent(stepName, ...) here, which sent badly-named events
    // ("Business Type" with spaces) with the whole formData as params AND
    // duplicated the properly-named GA events the components fire themselves
    // (business_category_confirmed, business_details_submit, ...). This hook
    // now ONLY records to the backend onboarding tracker; every GA4 event is
    // an explicit trackEvent() call at its own screen.
    await updateOnBoardingTracker(entry);

  };

  return { steps, trackStep };
}
